import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const services = [
    { id: 1, title: "System Re-engineering", category: "Legacy System Modernization", difficulty: "Beginner", description: "Re-engineer legacy systems to improve performance and scalability.", takenBy: 120 },
    { id: 2, title: "Data Migration", category: "Legacy System Modernization", difficulty: "Intermediate", description: "Migrate your legacy system data to modern platforms while ensuring data integrity.", takenBy: 95 },
    { id: 3, title: "Cloud Migration", category: "Legacy System Modernization", difficulty: "Advanced", description: "Move legacy systems to the cloud to improve flexibility, scalability, and efficiency.", takenBy: 85 },
    { id: 4, title: "Technology Stack Upgrade", category: "Legacy System Modernization", difficulty: "Intermediate", description: "Upgrade outdated technology stacks to modern frameworks and platforms.", takenBy: 110 },
    { id: 5, title: "Legacy Application Refactoring", category: "Legacy System Modernization", difficulty: "Advanced", description: "Refactor old applications to make them more modular and maintainable.", takenBy: 75 },
    { id: 6, title: "Microservices Implementation", category: "Legacy System Modernization", difficulty: "Advanced", description: "Break down monolithic applications into microservices for scalability and flexibility.", takenBy: 90 },
    { id: 7, title: "Automated Testing for Legacy Systems", category: "Legacy System Modernization", difficulty: "Intermediate", description: "Implement automated testing frameworks for legacy systems to ensure quality and reliability.", takenBy: 105 },
    { id: 8, title: "API Integration", category: "Legacy System Modernization", difficulty: "Beginner", description: "Integrate legacy systems with modern APIs to ensure interoperability with newer platforms.", takenBy: 130 },
];

const pageSize = 4;

function LegacySystemModernization() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredServices = services.filter(service => service.difficulty === activeTab);
    const paginatedServices = filteredServices.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Legacy System Modernization</Title>
                <Paragraph>Transform your outdated legacy systems to modern, scalable solutions with our comprehensive modernization services. Whether it's re-engineering, migration, or cloud adoption, we have you covered.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedServices.map((service) => (
                        <Col xs={24} sm={12} md={6} key={service.id}>
                            <Card hoverable>
                                <Title level={5}>{service.title}</Title>
                                <Tag color="blue">{service.category}</Tag>
                                <Tag color={service.difficulty === "Beginner" ? "green" : service.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {service.difficulty}
                                </Tag>
                                <Paragraph>{service.description}</Paragraph>
                                <Paragraph><UserOutlined /> {service.takenBy} systems modernized</Paragraph>
                                <Button type="primary">Start Project</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredServices.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default LegacySystemModernization;
